var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bookmark",attrs:{"title":_vm.isBookmarked ? 'Remove Bookmark' : 'Bookmark'},on:{"click":_vm.toggleBookmark}},[_c('img',{staticClass:"bookmark-icon",attrs:{"src":_vm.isBookmarked? '/images/icons/bookmark-black.svg' : '/images/icons/bookmark-white.svg',"alt":"Bookmark"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }